<template>
  <money
    :name="name"
    class="form-control form-control-sm"
    v-model="post"
    @input="send"
    @change="send"
    v-bind="money"
    :required="required"
  ></money>
</template>

<script>
import { Money } from "v-money";
export default {
  props: ["name", "validation", "content"],
  data() {
    return {
      post: this.content,
      money: {
        thousands: '.',
        prefix: 'Rp ',
        precision: 0,
      }
    };
  },
  components: {
    Money
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    }
  },
  methods: {
    send() {
      this.$emit("post", {
        name: this.name,
        value: this.post
      });
    }
  }
};
</script>